import Vue from 'vue'
import Vuex from 'vuex'

// import Firebase from 'Firebase'
// import 'Firebase/firestore'
import Firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/storage'
import router from '../router/index'

import invoicesstoremodule from './invoicesstoremodule'
import userstoremodule from './usersstoremodule'
import invoiceimportsstoremodule from './invoiceimportsstoremodule'
import createcampaignstoremodule from './createcampaignstoremodule'
import campaignstoremodule from './campaignstoremodule'
import claimsstoremodule from './claimsstoremodule'
import pairrequestsstoremodule from './pairrequestsstoremodule'
import customeraccountsstoremodule from './customeraccountsstoremodule'
import customeraccountuploadstoremodule from './customeraccountuploadstoremodule'
import userclaimreportstoremodule from './userclaimreportstoremodule.js'
import invoiceuploadstoremodule from './invoiceuploadstoremodule'
import generateclaimreportsmodule from './generateclaimreportsmodule'
import bannerstoremodule from './bannerstoremodule'
import notificationsstoremodule from './notificationsstoremodule'
// 20-Oct-2018, Luis: Phase2, configuration for invoice list display in APP.
import configurationstoremodule from './configurationstoremodule'

// var config = {
//   apiKey: 'AIzaSyBWpjYeB_8IEEizAeiUAUMJRs8FyH5yW-g',
//   authDomain: 'hoya-malaysia.firebaseapp.com',
//   projectId: 'hoya-malaysia',
//   databaseURL: 'https://hoya-malaysia.firebaseio.com/',
//   storageBucket: 'gs://hoya-malaysia.appspot.com'
// }

// const config = {
//   apiKey: "AIzaSyD8vQcqqzt7wHoWEnwCZY59FuTT9Bt8IgY",
//   authDomain: "hoya-app-80a63.firebaseapp.com",
//   databaseURL: "https://hoya-app-80a63-default-rtdb.asia-southeast1.firebasedatabase.app",
//   projectId: "hoya-app-80a63",
//   storageBucket: "hoya-app-80a63.firebasestorage.app",
//   messagingSenderId: "460904809715",
//   appId: "1:460904809715:web:fd5e6205760f6869c42386"
// };

const config = {
  apiKey: 'AIzaSyALPpAdKPWL4QiUH6lG0cvzxLWtqa1UYWw',
  authDomain: 'hoya-e-surprise.firebaseapp.com',
  databaseURL: 'https://hoya-e-surprise-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'hoya-e-surprise',
  storageBucket: 'hoya-e-surprise.firebasestorage.app',
  messagingSenderId: '411242157418',
  appId: '1:411242157418:web:047633d556fa341c678113',
  measurementId: 'G-55YHGCJV6P'
}
Firebase.initializeApp(config)

Vue.use(Vuex)

Firebase.auth().onAuthStateChanged(function (user) {
  state.currentUser = user
  console.log('user: ' + user)
  console.log('router: ' + router.currentRoute.path)
  if (router.currentRoute.path === '/login') {
    router.push('invoices')
  }
})

const state = {
  firebase: Firebase,
  firestoreDB: Firebase.firestore(),
  realtimeDb: Firebase.database(),
  fbStorage: Firebase.storage(),
  currentUser: null
}

const mutations = {
  logOut: function (state) {
    Firebase.auth().signOut().then(function () {
      router.push('login')
    })
  }
}

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    invstomod: invoicesstoremodule,
    usrstomod: userstoremodule,
    invimpmod: invoiceimportsstoremodule,
    crtcammod: createcampaignstoremodule,
    cammod: campaignstoremodule,
    claimmod: claimsstoremodule,
    pairmod: pairrequestsstoremodule,
    cusaccmod: customeraccountsstoremodule,
    cauploadmod: customeraccountuploadstoremodule,
    ucrmod: userclaimreportstoremodule,
    iumod: invoiceuploadstoremodule,
    gcrmod: generateclaimreportsmodule,
    bannermod: bannerstoremodule,
    notifmod: notificationsstoremodule,
    // 20-Oct-2018, Luis: Phase2, configuration for invoice list display in APP.
    configmod: configurationstoremodule
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js